import React from 'react';
import { FilterSection, AdvancedFilters } from "../../../components/ui";
import { SORT_OPTIONS } from "../../../constants/globalConstants";
import { useAuthStore } from "../../../store/authStore";

export const OrderingControlPanel = ({
  search, setSearch,
  filters, setFilters,
  sortBy, setSortBy,
  showAdvancedFilters, setShowAdvancedFilters,
  view, setView,
  onAddClick,
  onExport,
  isExporting,
  filterOptions = { locations: [], sources: [], assignees: [] },
  activityStats,
  onReset,
  isWorkspace = false,
  addLabel = "Create Quote"
}) => {
  const { user } = useAuthStore();
  const userRole = (user?.role || "").toLowerCase().trim().replace(/[-_\s]+/g, "-");
  
  // Define stage options for ordering
  const stageOptions = [
    { value: 'Draft', label: 'Draft' },
    { value: 'Pending', label: 'Pending Approval' },
    { value: 'Approved', label: 'Approved' },
    { value: 'Rejected', label: 'Rejected' },
  ];

  const filterConfig = {
    status: {
      label: 'Status',
      options: stageOptions,
    },
    location: {
      label: 'Location',
      options: filterOptions.locations?.map(city => ({ value: city, label: city })) || []
    },
    source: {
      label: 'Source',
      options: filterOptions.sources?.map(source => ({ value: source, label: source })) || []
    },
    assignedTo: {
      label: 'Assigned To',
      options: filterOptions.assignees?.map(a => ({ value: a.id, label: a.name })) || []
    }
  };

  return (
    <FilterSection
      search={search}
      setSearch={setSearch}
      filters={filters}
      setFilters={setFilters}
      onAddClick={onAddClick}
      addLabel={addLabel}
      isAdvancedFilterInline={true}
      statusOptions={isWorkspace ? stageOptions : []}
      AdvancedFiltersComponent={({ isInline }) => (
        <AdvancedFilters
          filters={filters}
          onFilterChange={(key, value) => setFilters(key, value)}
          sortBy={sortBy}
          onSortChange={setSortBy}
          sortOptions={SORT_OPTIONS}
          config={filterConfig}
          isInline={isInline}
        />
      )}
    >
      {isWorkspace && (
        <div className="bg-slate-50/50 p-1 rounded-md border border-slate-200/60 shrink-0">
          <select
            className="text-[13px] font-medium bg-white border border-slate-200 rounded-md px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-brand-blue text-slate-600 w-44"
            value={filters.category || "all"}
            onChange={e => setFilters('category', e.target.value)}
          >
            <option value="all">All Categories</option>
            <option value="Appliances">Appliances</option>
            <option value="Transport">Transport</option>
            <option value="Stone">Stone</option>
          </select>
        </div>
      )}
    </FilterSection>
  );
};
